import { render, staticRenderFns } from "./phoneBar.vue?vue&type=template&id=354460fb&scoped=true"
import script from "./phoneBar.vue?vue&type=script&lang=js"
export * from "./phoneBar.vue?vue&type=script&lang=js"
import style0 from "./phoneBar.vue?vue&type=style&index=0&id=354460fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354460fb",
  null
  
)

export default component.exports